import type { Lead } from '@/domain/leads';
import type { Unit } from '@/domain/units';
import queryString from 'query-string';

const gerRedirectUrl = (
  path: string,
  unitId: number,
  lead: Pick<Lead, 'firstName' | 'lastName' | 'email' | 'phone' | 'createLoginId'>,
) => {
  const queryParams = {
    firstName: lead.firstName,
    lastName: lead.lastName,
    email: lead.email,
    phoneNumber: lead.phone,
    unitId,
    hasLogin: lead.createLoginId !== 0,
  };

  return `${path}?${queryString.stringify(queryParams)}`;
};

export const getApplyNowLink = (
  unitId: number,
  lead: Pick<Lead, 'firstName' | 'lastName' | 'email' | 'phone' | 'createLoginId'>,
) => gerRedirectUrl(`/unit-applications/unit/${unitId}/create`, unitId, lead);

export const getUnitShowingLink = (
  unit: Pick<Unit, 'id' | 'foreignShowingLink'>,
  lead: Pick<Lead, 'firstName' | 'lastName' | 'email' | 'phone' | 'createLoginId'>,
) => {
  if (unit.foreignShowingLink) {
    return unit.foreignShowingLink;
  }
  return gerRedirectUrl(`/showings/schedule`, unit.id, lead);
};
